export default "__VITE_ASSET__CAeLwLD7__"